import React, { useEffect, useState } from 'react';
import { Container, Grid, Card, CardMedia, CardContent, Typography, Box, Divider } from '@mui/material';
import { getNews } from '../api/news';

const NewsList = () => {
    const [news, setNews] = useState([]);

    useEffect(() => {
        const fetchNews = async () => {
            try {
                const response = await getNews();
                setNews(response.data.news || response.data);
                console.log('News fetched:', response.data);
            } catch (error) {
                console.error('Error fetching news:', error);
                setNews([]);
            }
        };
        fetchNews();
    }, []);

    if (!Array.isArray(news)) {
        return <Typography>Loading news...</Typography>;
    }

    return (
        <Container sx={{ py: 4 }}>
            <Typography variant="h4" gutterBottom>Latest News</Typography>
            <Grid container spacing={4}>
                {news.map((item) => (
                    <Grid item key={item._id} xs={12} sm={6}>
                        <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                            {item.image && (
                                <CardMedia
                                    component="img"
                                    height="250"
                                    image={item.image.url}
                                    alt={item.title}
                                    sx={{ objectFit: 'cover' }}
                                />
                            )}
                            <CardContent sx={{ flexGrow: 1 }}>
                                <Typography gutterBottom variant="h5" component="h2">
                                    {item.title}
                                </Typography>
                                <Divider sx={{ my: 2 }} />
                                <Typography variant="body1" color="text.secondary">
                                    {item.content}
                                </Typography>
                                <Box sx={{ mt: 2 }}>
                                    <Typography variant="caption" color="text.secondary">
                                        Published on: {new Date(item.createdAt).toLocaleDateString('en-US', {
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric'
                                        })}
                                    </Typography>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default NewsList;
